/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { Link as ScrollLink } from 'react-scroll';
import { Link as RouterLink } from 'react-router-dom';

export default function Navbar() {
  const [navbarOpen, setNavbarOpen] = useState(false);
  const [sticky, setSticky] = useState(false);

  // Handle sticky navbar on scroll
  useEffect(() => {
    const handleScroll = () => {
      setSticky(window.scrollY > 500);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { name: 'Home', to: 'home' },
    { name: 'Why sofia', to: 'why-sofia' },
    { name: 'Service', to: 'Service' },
    { name: 'Who needs sofia', to: 'who-needs-sofia' },
  
  ];

  return (
    <div className={`${sticky ? 'dark-nav' : ''}`}>
      <nav className="top-0 fixed z-50 w-full flex items-center justify-between px-4 py-3 navbar-expand-lg bg-white shadow">
        <div className="container mx-auto flex justify-between items-center">

         

          {/* Mobile Menu Button */}
          <button
            className="cursor-pointer text-xl px-3 py-1 border-none rounded bg-transparent lg:hidden outline-none"
            type="button"
            onClick={() => setNavbarOpen(!navbarOpen)}
          >
            <i className="fas fa-bars"></i>
          </button>

          {/* Menu Section */}
          <div className={`lg:flex flex-grow items-center ${navbarOpen ? 'block' : 'hidden'}`}>
            <ul className="flex flex-col lg:flex-row list-none lg:ml-auto">
              {navItems.map((item) => (
                <li className="flex items-center" key={item.to}>
                  <button
                    className="cursor-pointer text-xl px-3 py-1 border-none rounded bg-transparent outline-none focus:outline-none"

                  >   <ScrollLink

                    to={item.to}
                    smooth
                    offset={-200}
                    duration={500}
                    className="hover:text-blueGray-500 text-blueGray-700 px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold"
                  >
                      {item.name}
                    </ScrollLink>
                  </button> </li>
              ))}
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
}


// /*eslint-disable*/
// import React from "react";
// import { Link } from "react-router-dom";
// // components

// import IndexDropdown from "components/Dropdowns/IndexDropdown.js";

// export default function Navbar(props) {
//   const [navbarOpen, setNavbarOpen] = React.useState(false);
//   return (
//     <>
//       <nav className="top-0 fixed z-50 w-full flex flex-wrap items-center justify-between px-2 py-3 navbar-expand-lg bg-white shadow">
//         <div className="container px-4 mx-auto flex flex-wrap items-center justify-between">
//           <div className="w-full relative flex justify-between lg:w-auto lg:static lg:block lg:justify-start">
//             <Link
//               to="/"
//               className="text-blueGray-700 text-sm font-bold leading-relaxed inline-block mr-4 py-2 whitespace-nowrap uppercase"
//             >
//               Notus React
//             </Link>
//             <button
//               className="cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent block lg:hidden outline-none focus:outline-none"
//               type="button"
//               onClick={() => setNavbarOpen(!navbarOpen)}
//             >
//               <i className="fas fa-bars"></i>
//             </button>
//           </div>
//           <div
//             className={
//               "lg:flex flex-grow items-center bg-white lg:bg-opacity-0 lg:shadow-none" +
//               (navbarOpen ? " block" : " hidden")
//             }
//             id="example-navbar-warning"
//           >
//             {/* <ul className="flex flex-col lg:flex-row list-none mr-auto">
//               <li className="flex items-center">
//                 <a
//                   className="hover:text-blueGray-500 text-blueGray-700 px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold"
//                   href="https://www.creative-tim.com/learning-lab/tailwind/react/overview/notus?ref=nr-index-navbar"
//                 >
//                   <i className="text-blueGray-400 far fa-file-alt text-lg leading-lg mr-2" />{" "}
//                   Docs
//                 </a>
//               </li>
//             </ul> */}
//             <ul className="flex flex-col lg:flex-row list-none lg:ml-auto">
//               {/* <li className="flex items-center">
//                 <IndexDropdown />
//               </li> */}
//               <li className="flex items-center">
//                 <a
//                   className="hover:text-blueGray-500 text-blueGray-700 px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold"
//                   href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fdemos.creative-tim.com%2Fnotus-react%2F%23%2F"
//                   target="_blank"
//                 >
//                   {/* <i className="text-blueGray-400 fab fa-facebook text-lg leading-lg " /> */}
//                   <span className="  inline-block ml-2">Home</span>
//                 </a>
//               </li>

//               <li className="flex items-center">
//                 <a
//                   className="hover:text-blueGray-500 text-blueGray-700 px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold"
//                   href="https://twitter.com/intent/tweet?url=https%3A%2F%2Fdemos.creative-tim.com%2Fnotus-react%2F%23%2F&text=Start%20your%20development%20with%20a%20Free%20Tailwind%20CSS%20and%20React%20UI%20Kit%20and%20Admin.%20Let%20Notus%20React%20amaze%20you%20with%20its%20cool%20features%20and%20build%20tools%20and%20get%20your%20project%20to%20a%20whole%20new%20level.%20"
//                   target="_blank"
//                 >
//                   {/* <i className="text-blueGray-400 fab fa-twitter text-lg leading-lg " /> */}
//                   <span className=" inline-block ml-2">About</span>
//                 </a>
//               </li>

//               <li className="flex items-center">
//                 <a
//                   className="hover:text-blueGray-500 text-blueGray-700 px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold"
//                   href="https://github.com/creativetimofficial/notus-react?ref=nr-index-navbar"
//                   target="_blank"
//                 >
//                   {/* <i className="text-blueGray-400 fab fa-github text-lg leading-lg " /> */}
//                   <span className=" inline-block ml-2">Contatc</span>
//                 </a>
//               </li>

//               {/* <li className="flex items-center">
//                 <button
//                   className="bg-lightBlue-500 text-white active:bg-lightBlue-600 text-xs font-bold uppercase px-4 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none lg:mr-1 lg:mb-0 ml-3 mb-3 ease-linear transition-all duration-150"
//                   type="button"
//                 >
//                   <i className="fas fa-arrow-alt-circle-down"></i> Download
//                 </button>
//               </li> */}
//             </ul>
//           </div>
//         </div>
//       </nav>
//     </>
//   );
// }
